// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Unscramble from "../Unscramble/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var errorsIsSymbol = {
    reflectSymbol: function () {
        return "errors";
    }
};
var showArray = /* #__PURE__ */ Data_Show.showArray(Data_Show.showString);
var ValidationFailedIsSymbol = {
    reflectSymbol: function () {
        return "ValidationFailed";
    }
};
var eqArray = /* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqString);
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Foreign_Object.eqObject(eqArray));
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var arrayEncode = /* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode);
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var decodeArray1 = /* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1);
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons1 = /* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil);
var arrayDecode = /* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode);
var messageIsSymbol = {
    reflectSymbol: function () {
        return "message";
    }
};
var pathIsSymbol = {
    reflectSymbol: function () {
        return "path";
    }
};
var ErrorIsSymbol = {
    reflectSymbol: function () {
        return "Error";
    }
};
var ValidationErrorsIsSymbol = {
    reflectSymbol: function () {
        return "ValidationErrors";
    }
};
var eq2 = /* #__PURE__ */ Data_Eq.eq(eqArray);
var ValidationFailed = function (x) {
    return x;
};
var $$Error = function (x) {
    return x;
};
var ValidationErrors = function (x) {
    return x;
};
var semigroupValidationErrors = {
    append: function (v) {
        return function (v1) {
            return append(v)(v1);
        };
    }
};
var newtypeValidationFailed_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeValidationErrors_ = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidValidationErrors = {
    mempty: /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray),
    Semigroup0: function () {
        return semigroupValidationErrors;
    }
};
var getTranslationValidationF = {
    getTranslation: function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.validationError);
    }
};
var genericValidationFailed_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showValidationFailed = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericValidationFailed_)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(errorsIsSymbol)(/* #__PURE__ */ Foreign_Object.showObject(showArray)))))(ValidationFailedIsSymbol))
};
var genericValidationErrors_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var eqValidationFailed = {
    eq: function (x) {
        return function (y) {
            return eq(x.errors)(y.errors);
        };
    }
};
var encodeValidationFailed = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericValidationFailed_)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ValidationFailedIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons1(errorsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.objectEncode(arrayEncode)))))))
};
var decodeValidationFailed = /* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(errorsIsSymbol)(/* #__PURE__ */ Unscramble.decodeObject1(decodeArray1))(Unscramble.decodeRecordNil));
var decodeValidationFailed1 = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericValidationFailed_)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ValidationFailedIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(errorsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.objectDecode(arrayDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var udecode = /* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(messageIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(pathIsSymbol)(decodeArray1)(Unscramble.decodeRecordNil)));
var decodeValidationErrors = /* #__PURE__ */ Unscramble.decodeArray1(udecode);
var newtypeError = {
    Coercible0: function () {
        return undefined;
    }
};
var genericError = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericError)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(messageIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(pathIsSymbol)(showArray))(Data_Show.showString))))(ErrorIsSymbol))
};
var showValidationErrors = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericValidationErrors_)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(showError)))(ValidationErrorsIsSymbol))
};
var eqError = {
    eq: function (x) {
        return function (y) {
            return x.message === y.message && eq2(x.path)(y.path);
        };
    }
};
var eq3 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(eqError));
var eqValidationErrors = {
    eq: function (x) {
        return function (y) {
            return eq3(x)(y);
        };
    }
};
var encodeError = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericError)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ErrorIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(pathIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(arrayEncode)))(messageIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var encodeValidationErrors = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericValidationErrors_)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ValidationErrorsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeError)))))
};
var decodeError = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericError)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ErrorIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(pathIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(arrayDecode))())(messageIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeValidationErrors1 = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericValidationErrors_)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ValidationErrorsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeError))))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    $$Error as Error,
    ValidationErrors,
    ValidationFailed,
    newtypeError,
    genericError,
    eqError,
    showError,
    decodeError,
    encodeError,
    udecode,
    newtypeValidationErrors_,
    genericValidationErrors_,
    eqValidationErrors,
    showValidationErrors,
    decodeValidationErrors1,
    encodeValidationErrors,
    decodeValidationErrors,
    monoidValidationErrors,
    semigroupValidationErrors,
    eqValidationFailed,
    showValidationFailed,
    newtypeValidationFailed_,
    genericValidationFailed_,
    decodeValidationFailed1,
    encodeValidationFailed,
    decodeValidationFailed,
    getTranslationValidationF
};
